export const isSharedFolder = (folder, allocations) => {
  if (!folder) return false;
  if (folder.sharedWithMe) return true;
  if (allocations && allocations.length > 0) return true;
  return folder.sharedByMe && allocations === undefined;
};
